import { getReqVerificationTokenHeaderKey, getReqVerificationToken } from '@/script/common/xsrf';
import { AxiosRequestConfig } from 'axios';

export function applyJQueryXsrf (ajaxRequest: any) {
	const cb = ajaxRequest.beforeSend;

	ajaxRequest.beforeSend = (req: any) => {
		const key = getReqVerificationTokenHeaderKey();
		const token = getReqVerificationToken();

		if (token) {
			req.setRequestHeader(key, token);
		}

		if (cb) {
			cb();
		}
	};
}

export function applyAxiosXsrf (config: AxiosRequestConfig) {
	const key = getReqVerificationTokenHeaderKey();
	const token = getReqVerificationToken();

	const headers: { [id: string]: string | null } = config.headers || {};
	headers[key] = token;
	config.headers = headers;
}
